import { POST_MESSAGE_FAILURE, POST_MESSAGE_SUCCESS } from './actionTypes';
import { postMessageAPI } from '../api/messageAPI';

export function postMessageSuccess(data) { return { data, type: POST_MESSAGE_SUCCESS }; }
export function postMessageFailure(response) { return { response, type: POST_MESSAGE_FAILURE }; }

export function postMessage(name, email, subject, message) {
    return dispatch => postMessageAPI(name, email, subject, message)
        .then(response => dispatch(postMessageSuccess(response.data)))
        .catch(error => dispatch(postMessageFailure(error.response)));
}
